import { LegalPage } from './LegalPage';

/** Copy lives in content/fallbacks.ts (legal.cookies / legal.cookiesMeta) and is
 *  editable from admin → Marketing content → Legal. */
export function Cookies() {
  return <LegalPage kind="cookies" />;
}
